import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ddd435d6")

_pushScopeId("data-v-ddd435d6")
const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "disbale-inquiry-contanier" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "empty_img",
  src: "https://wechatdn.yiautos.com/channel_query/v2/empty.png"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "warm-text" }, " 呜呜呜，系统暂未收集到该车型的报价，你也可以尝试其他车型 ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "warm-text mgb" }, "或从下方找到服务顾问1对1对您进行询车服务", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_contact = _resolveComponent("contact")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", {
        class: "re-quiry",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inquiry && _ctx.inquiry(...args)))
      }, "重新询价"),
      _hoisted_5,
      _createVNode(_component_contact, {
        class: "footer",
        servicePhone: _ctx.servicePhone,
        qrCode: _ctx.qrCode
      }, null, 8, ["servicePhone", "qrCode"])
    ])
  ]))
})